import "./scss/app.scss";
import { h, render, Component } from "preact";
import PropTypes from "prop-types";

import AccountOverview from "./components/AccountOverview.js";
import Navigation from "./components/Navigation.js";
import NotificationBanner from "./components/NotificationBanner.js";
import ViewsWrapper from "./components/ViewsWrapper.js";
import AccountInfoProvider from "./components/AccountInfoProvider.js";
import LoginPanel from "./components/LoginPanel.js";

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.client.js";

class Dashboard extends Component {
  runVIPcheck = () => {
    liveagent.init("https://d.la3-c2-ia2.salesforceliveagent.com/chat", "572410000008jas", "00D41000000fmlp");
    if (!window._laq) {
      window._laq = [];
    }
    window._laq.push(
      function () {
        liveagent.showWhenOnline("573410000008luG", document.getElementById("liveagent_button_online_573410000008luG"));
        // liveagent.showWhenOffline('573410000008luG', document.getElementById('liveagent_button_offline_573410000008luG'));
        liveagent.addCustomDetail("First Name", "");
        liveagent.addCustomDetail("Last Name", this.context.userData.accountInfo.name);
        liveagent.addCustomDetail("Contact E-mail", this.context.userData.accountInfo.contactInfo.email);
        liveagent
          .findOrCreate("Contact")
          .map("Email", "Contact E-mail", true, true, true)
          .map("FirstName", "First Name", false, false, true)
          .map("LastName", "Last Name", false, false, true)
          .map("Phone", "Phone Number", false, false, true);
      }.bind(this)
    );
  };

  verifyEmailAddress = (key) => {
    fetch("https://api.hirezstudios.com/acct/verify", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: `{"key": "${key}"}`,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === 200) {
          this.setState({
            notificationType: "success",
            notificationTime: 10000,
            notificationCopy: "Your email address has been verified.",
          });
        } else {
          this.setState({
            notificationType: "fail",
            notificationTime: 10000,
            notificationCopy: "Unable to verify your email address. Please try again.",
          });
        }
      });
  };

  readCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };

  eraseCookie = (name) => {
    this.createCookie(name, "", -1);
  };

  createCookie = (name, value, days) => {
    let expires;
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
  };

  injectScript = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.async = true;
      script.src = src;
      script.addEventListener("load", resolve);
      script.addEventListener("error", () => reject("Error loading script."));
      script.addEventListener("abort", () => reject("Script loading aborted."));
      document.head.appendChild(script);
    });
  };

  parseJwt = (token) => {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  };

  getURLParam = (name, url) => {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regexS = "[\\?&]" + name + "=([^&#]*)";
    let regex = new RegExp(regexS);
    let results = regex.exec(url);
    return results == null ? null : results[1];
  };

  deployNotification = (type, time, copy) => {
    if (type) {
      this.setState({ notificationType: type });
      this.setState({ notificationTime: time });
      this.setState({ notificationCopy: copy });
    }
  };

  windowChange = () => {
    this.setState({ windowWidth: window.innerWidth });
  };
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
      logInToggled: false,
      acctUsername: undefined,
      chatActive: false,
      windowWidth: undefined,
      hash: null,
      dev: false,
    };
  }

  componentDidMount() {
    //dev state
    if (this.getURLParam("dev")) {
      document.body.classList.add("oauth");
      this.setState({
        dev: true,
        origin: window.location.origin,
      });
    }

    //Google Analytics
    this.injectScript("https://www.googletagmanager.com/gtag/js?id=UA-128185289-1");
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "UA-128185289-1");

    // Google Tag Manager
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-TLR4LFV");
    //End Google Tag Manager

    if (window.location.hash === "#forgot-username" || window.location.hash === "#forgot-password") {
      this.setState({ hash: window.location.hash.substr(1) });
    }
    if (this.getURLParam("key")) {
      this.verifyEmailAddress(this.getURLParam("key"));
    }
    if (this.readCookie("HZAcctWebToken") || this.getURLParam("jwt")) {
      document.body.classList.remove("blue");
      this.setState({ loggedIn: true });
      let token, jwtWebToken;
      if (this.getURLParam("jwt")) {
        token = this.getURLParam("jwt");
        jwtWebToken = this.parseJwt(token);
        history.pushState({}, document.title, "/");
        this.createCookie("HZAcctWebToken", jwtWebToken.jti, 30);
        this.createCookie("JWT", token, 30);
      } else {
        token = this.readCookie("HZAcctWebToken");
      }
      fetch("https://api.hirezstudios.com/acct/info", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: `{"webToken": "${token}"}`,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.name) {
            this.setState({ acctUsername: response.name });
          }
          if (!this.readCookie("HZAccountId")) {
            this.createCookie("HZAccountId", response.accountId, 30);
          }
        });
    }

    this.windowChange();
    window.scrollTo(0, 0);
  }

  componentDidUpdate = () => {
    if (this.state.loggedIn && !this.state.logInToggled) {
      window.addEventListener("resize", this.windowChange);
      this.setState({ logInToggled: true });
    }
    if (this.state.loggedIn && this.context.userData.accountInfo) {
      //Mutation observer for the  liveagent element
      const targetNode = document.getElementById("liveagent_button_online_573410000008luG");
      const config = { attributes: true, childList: true };

      const callback = function (mutationsList) {
        for (let mutation of mutationsList) {
          if (mutation.type === "attributes") {
            if (targetNode.style.display === "") {
              this.setState({ chatActive: true });
            } else {
              this.setState({ chatActive: false });
            }
          }
        }
      }.bind(this);

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);

      this.injectScript("https://c.la3-c2-ia2.salesforceliveagent.com/content/g/js/49.0/deployment.js").then(
        function () {
          if (document.readyState === "complete") {
            this.runVIPcheck();
          }
          document.onreadystatechange = function () {
            this.runVIPcheck();
          }.bind(this);
        }.bind(this)
      );
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.windowChange);
    localStorage.removeItem("linkRedirectUrl");
  }

  render() {
    const { userData } = this.context;
    if (
      !this.state.dev &&
      this.state.loggedIn &&
      this.state.hash !== "forgot-password" &&
      this.state.hash !== "forgot-username"
    ) {
      return (
        <div className="hirez-acct-dashboard">
          <div id="liveagent_button_online_573410000008luG" style="display: none; width: 0; height: 0" />
          <div className="master-username">{this.state.acctUsername ? this.state.acctUsername : ""}</div>
          <div className="center-wrapper">
            <Navigation
              windowWidth={this.state.windowWidth}
              chatActive={this.state.chatActive}
              isVIP={userData.accountInfo && userData.accountInfo.vip}
              isLoggedIn={this.state.loggedIn}
            />
            <div className="wrapped-content">
              <NotificationBanner
                type={this.state.notificationType}
                time={this.state.notificationTime}
                copy={this.state.notificationCopy}
              />
              <ViewsWrapper
                chatActive={this.state.chatActive}
                isVIP={userData.accountInfo && userData.accountInfo.vip}
                webToken={this.readCookie("HZAcctWebToken")}
                notification={this.deployNotification}
                windowWidth={this.state.windowWidth}
              />
            </div>
          </div>
        </div>
      );
    } else if (this.state.dev) {
      return (
        <div className="oauth-panel">
          <p>Please log into your Hi-Rez Studios Account.</p>
          <a
            href={`https://ben.mechanicalghosts.com/?grant_type=jwt&client_id=1&redirect_uri=${this.state.origin}&scope=user&state=XyZ`}
          >
            Log In
          </a>
        </div>
      );
    }
    return (
      <div className="hirez-acct-dashboard panel">
        <script src="https://js.hcaptcha.com/1/api.js" async defer />
        <LoginPanel hash={this.state.hash} windowWidth={this.state.windowWidth} />
      </div>
    );
  }
}

if (typeof window !== "undefined") {
  render(
    <I18nextProvider i18n={i18n}>
      <AccountInfoProvider>
        <Dashboard />
      </AccountInfoProvider>
    </I18nextProvider>,
    document.body
  );
}



// WEBPACK FOOTER //
// ./index.js